import { render, staticRenderFns } from "./classTable.vue?vue&type=template&id=0e0fd6fd"
import script from "./classTable.vue?vue&type=script&lang=js"
export * from "./classTable.vue?vue&type=script&lang=js"
import style0 from "./classTable.vue?vue&type=style&index=0&id=0e0fd6fd&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports